'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import UIFlex from 'UIComponents/layout/UIFlex';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
export default function PublicViewLoading() {
  return /*#__PURE__*/_jsx(UIFlex, {
    align: "center",
    children: /*#__PURE__*/_jsx(UILoadingSpinner, {
      layout: "centered",
      grow: true
    })
  });
}